import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChildren } from "@angular/core"
import { Subscription } from "rxjs"
import { ImageFilterService } from "@shared/services/image-filter.service"

@Component({
  selector: "ag-tab",
  standalone: false,
  templateUrl: "./ag-tab.component.html",
  styleUrl: "./ag-tab.component.scss",
})
export class AgTabComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() tabList: agTab[] = []
  @Input() selectedTab: string = ""
  @Input() width: string = "100%"
  @Input() activeColor: string = "#222222"
  @Input() paddingLeft: string = "0px"
  @Input() imageFilter: string = "none"

  @Output() tabSelected = new EventEmitter<string>()

  constructor(public imageFilters: ImageFilterService) {}

  @ViewChildren("tab") tabEls!: QueryList<ElementRef<HTMLElement>>

  indicatorLeft = 0
  indicatorWidth = 0

  private tabsSub?: Subscription

  ngAfterViewInit() {
    this.updateIndicator()
    this.tabsSub = this.tabEls.changes.subscribe(() => this.updateIndicator())
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["selectedTab"] || changes["tabList"]) {
      queueMicrotask(() => this.updateIndicator())
    }
  }

  ngOnDestroy() {
    this.tabsSub?.unsubscribe()
  }

  @HostListener("window:resize")
  onResize() {
    this.updateIndicator()
  }

  selectTab(tab: agTab) {
    if (tab.isDisabled) {
      return
    }
    this.selectedTab = tab.title
    this.tabSelected.emit(tab.title)
    this.updateIndicator()
  }

  private updateIndicator() {
    if (!this.tabEls) {
      return
    }
    const index = this.tabList.findIndex(t => t.title === this.selectedTab)
    if (index < 0) {
      this.indicatorWidth = 0
      return
    }
    const el = this.tabEls.toArray()[index]?.nativeElement
    if (!el) {
      this.indicatorWidth = 0
      return
    }
    this.indicatorLeft = el.offsetLeft
    this.indicatorWidth = el.offsetWidth
  }
}

export type agTab = { title: string; notification: number; image: string | null; isDisabled: boolean }
